export type Arrival = {
  referrer: string;
  url: string;
};

const Arrivals = () => {
  // keepalive lets the replay outlive the reload an explicit answer triggers
  const replay = (arrival: Arrival): Promise<void> =>
    fetch('/api/arrival', {
      body: JSON.stringify(arrival),
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      method: 'POST',
    })
      .then(() => undefined)
      .catch(() => undefined);

  return Object.freeze({ replay });
};

export default Arrivals();
